/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiBridgeSettingsFieldMapping } from './InternalApiBridgeSettingsFieldMapping';
import {
    InternalApiBridgeSettingsFieldMappingFromJSON,
    InternalApiBridgeSettingsFieldMappingFromJSONTyped,
    InternalApiBridgeSettingsFieldMappingToJSON,
    InternalApiBridgeSettingsFieldMappingToJSONTyped,
} from './InternalApiBridgeSettingsFieldMapping';

/**
 * 
 * @export
 * @interface InternalApiBridgeRecipientMappingConf
 */
export interface InternalApiBridgeRecipientMappingConf {
    /**
     * 
     * @type {string}
     * @memberof InternalApiBridgeRecipientMappingConf
     */
    fieldType: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiBridgeRecipientMappingConf
     */
    fieldIds: Array<string>;
    /**
     * 
     * @type {Array<InternalApiBridgeSettingsFieldMapping>}
     * @memberof InternalApiBridgeRecipientMappingConf
     */
    fieldMappings: Array<InternalApiBridgeSettingsFieldMapping>;
}

/**
 * Check if a given object implements the InternalApiBridgeRecipientMappingConf interface.
 */
export function instanceOfInternalApiBridgeRecipientMappingConf(value: object): value is InternalApiBridgeRecipientMappingConf {
    if (!('fieldType' in value) || value['fieldType'] === undefined) return false;
    if (!('fieldIds' in value) || value['fieldIds'] === undefined) return false;
    if (!('fieldMappings' in value) || value['fieldMappings'] === undefined) return false;
    return true;
}

export function InternalApiBridgeRecipientMappingConfFromJSON(json: any): InternalApiBridgeRecipientMappingConf {
    return InternalApiBridgeRecipientMappingConfFromJSONTyped(json, false);
}

export function InternalApiBridgeRecipientMappingConfFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBridgeRecipientMappingConf {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldType': json['fieldType'],
        'fieldIds': json['fieldIds'],
        'fieldMappings': ((json['fieldMappings'] as Array<any>).map(InternalApiBridgeSettingsFieldMappingFromJSON)),
    };
}

export function InternalApiBridgeRecipientMappingConfToJSON(json: any): InternalApiBridgeRecipientMappingConf {
    return InternalApiBridgeRecipientMappingConfToJSONTyped(json, false);
}

export function InternalApiBridgeRecipientMappingConfToJSONTyped(value?: InternalApiBridgeRecipientMappingConf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldType': value['fieldType'],
        'fieldIds': value['fieldIds'],
        'fieldMappings': ((value['fieldMappings'] as Array<any>).map(InternalApiBridgeSettingsFieldMappingToJSON)),
    };
}

